export const MAX_STRING = 175;
